import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Ciudades } from "../Paises/Ciudades/Ciudades";
import { Localidades } from "../Paises/Localidades/Localidades";
import { Paises } from "../Paises/Paises";
import { Provincias } from "../Paises/Provincias/Provincias";
import { Personal } from "../Personal/Personal";
import { PuestosTrabajo } from "../PuestosTrabajo/PuestosTrabajo";

const columns = () =>
(
    {
        c_pais_id: new EntityColumn<string>({ name: 'c_pais_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'País' }),
        c_provincia_id: new EntityColumn<string>({ name: 'c_provincia_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Provincia' }),
        c_ciudad_id: new EntityColumn<string>({ name: 'c_ciudad_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Ciudad' }),
        c_localidad_id: new EntityColumn<string>({ name: 'c_localidad_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Localidad' }),
        vc_puestos: new EntityColumn<string[]>({ name: 'vc_puestos', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Puestos', isArray: true }),
        vc_personal: new EntityColumn<string[]>({ name: 'vc_personal', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Personal', isArray: true }),
        vc_supervision: new EntityColumn<string[]>({ name: 'vc_supervision', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Supervisión', isArray: true }),
        ...DefaultColumns()
    }
)

const lookups = () =>
(
    {
        'Paises': {
            name: 'Paises',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Paises(client, parentKeys)
        },
        'Provincias': {
            name: 'Provincias',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Provincias(client, parentKeys)
        },
        'Ciudades': {
            name: 'Ciudades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Ciudades(client, parentKeys)
        },
        'Localidades': {
            name: 'Localidades',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Localidades(client, parentKeys)
        },
        'Puestos': {
            name: 'Puestos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new PuestosTrabajo(client, parentKeys)
        },
        'Personal': {
            name: 'Personal',
            view: 'perl_brwStandard',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
        'Supervision': {
            name: 'Supervision',
            view: 'perl_brwStandard',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        }
    }
)

export class AppSupervisorPersonalFiltersDef extends EntityDefinition {

    columns = columns();
    views = {};
    lookups = lookups();

    constructor() {
        super('AppSupervisorPersonalFilters');
    }
}